import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  svg: {
    width: 'auto',
    height: theme.spacing(3.5),
  },
}));

/**
 * Collapsed-sidebar mark: a power glyph echoing the Indiana Office of
 * Technology logo (a green power ring around the state outline). The stroke
 * color comes from `palette.branding.iconColor` so each theme can tint it.
 */
const LogoIcon = () => {
  const classes = useStyles();
  const theme = useTheme();
  const color: string =
    (theme.palette as any).branding?.iconColor ?? theme.palette.secondary.main;

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      role="img"
      aria-label="Home"
    >
      <path
        d="M15.5 12.5A17 17 0 1 0 32.5 12.5"
        fill="none"
        stroke={color}
        strokeWidth="5"
        strokeLinecap="round"
      />
      <line
        x1="24"
        y1="4"
        x2="24"
        y2="22"
        stroke={color}
        strokeWidth="5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default LogoIcon;
